// in order to not make huge changes to the system, but at some point with a general move
// in the direction of date-fns-tz instead of moment-timezone,  we will need to instead change the constant
export const adaptDateFormat = (dateFormat) => dateFormat.replace('DD', 'dd');
